import PropTypes from 'prop-types'

import FormWrapper from '@/components/form/Wrapper';
import { useAppAlert } from '@Components/AppAlert';
import RouterProvider, { useParams } from '@Components/RouterProvider';
import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';
import history from 'utils/history';

import Form from '../components/Form';
import URLGeneratorForm from '../components/FormURLGenerator';
import Heading from '../components/Heading';
import TabsRouter from '../components/TabsRouter';
import { AllocationActiveProvider, useAllocationActive } from '../components/context';
import { AllocationProvider, useAllocationStore } from '../store';
import BucketLayout from '../views/bucket/Layout';
import SubidLayout from '../views/subid/Layout';
import TransactionsLayout from '../views/transaction/Layout';
import { useState } from 'react';

const AllocationFormPropTypes = {
  match: PropTypes.object,
  type: PropTypes.oneOf(['details', 'attributes', 'verifications']),
}

function AllocationForm({ type }) {
  const { collection: { item, useLoad, useSubmit } } = useAllocationStore()
  const { handleSuccess, handleError } = useAppAlert()
  const { id } = useParams()
  const { active } = useAllocationActive()

  const loadData = useLoad(id)
  const handleSubmit = useSubmit()

  const [offers, setOffers] = useState()
  const [forms, setForms] = useState()

  function handleClickSidebarClose() {
    history.push('/offer/allocations');
  }

  async function handleSubmitAndClose(payload) {
    try {
      await handleSubmit({ ...payload, active })
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `Allocation ${message}.`)
      !payload.id && handleClickSidebarClose()
      await loadData()

      if (payload) {
        payload.offers && setOffers(payload.offers)
        payload.forms && setForms(payload.forms)
      }
    } catch {
      handleError('Error', 'Allocation was not saved.')
    }
  }

  if (!item) return null

  return <>
    <FormWrapper title='Allocation'>
      <Form data={item} type={type} handleSubmit={handleSubmitAndClose} onCancel={handleClickSidebarClose} />
    </FormWrapper>
  </>
}

AllocationForm.defaultProps = {
  type: 'details',
}

AllocationForm.propTypes = AllocationFormPropTypes

function AllocationFormWrapper() {
  const { id } = useParams()
  const { collection: { useLoad, item } } = useAllocationStore()
  useLoad(id)

  return <>
    <AllocationActiveProvider item={item}>
      <Heading />
      <TabsRouter />
      <Router>
        <PrivateRoute path="/offer/allocations/:id/subids" component={SubidLayout} />
        <PrivateRoute path="/offer/allocations/:id/buckets" component={BucketLayout} />
        <PrivateRoute path="/offer/allocations/:id/transactions" component={TransactionsLayout} />
        <PrivateRoute path="/offer/allocations/:id/generator" component={URLGeneratorForm} />
        <PrivateRoute path={["/offer/allocations/add", "/offer/allocations/:id"]} component={AllocationForm} />
      </Router>
    </AllocationActiveProvider>
  </>
}

export default function AllocationFormLayout() {
  return <RouterProvider>
    <AllocationProvider>
      <AllocationFormWrapper />
    </AllocationProvider>
  </RouterProvider>
}
